export default __webpack_public_path__ + "static/media/singulare.2890f6d5.png";